import broadcast from "@/api/broadcast";
import type {App} from "vue";

export default {
    install(app: App): void {

        app.provide('$broadcast', broadcast);
        app.config.globalProperties.$broadcast = broadcast;
    }
}